/** Palette tokens per Bible §2. Numbers are 0xRRGGBB for Pixi. */
export const PALETTE = {
  skyTop: 0x8fd3ff,
  skyBottom: 0xffe9b8,
  earth: 0xf2a950, // earth.top
  earthMid: 0xd98b3b,
  earthDark: 0xa8622a, // earth.shadow
  earthSpeck: 0xc27a34,
  tunnel: 0x5a3521,
  tunnelGlow: 0x8c5a3c,
  gems: [0xff4d6d, 0x35d07f, 0x3b8bff, 0xb66cff, 0xffc93c] as const, // ruby, emerald, sapphire, amethyst, topaz
  gemSparkle: 0xffffff,
  sack: 0xf4e6c8,
  sackShade: 0xc9a87a,
  sackTie: 0x8a6a3a,
  gold: 0xffd23f,
  goldShade: 0xff9f1c,
  pip: 0xffcf5c,
  pipBody: 0x4aa8ff,
  pipLamp: 0xfff6c8,
  crawler: 0x4ecdc4,
  crawlerAlt: 0xb39ddb,
  borer: 0xff3d8a,
  borerAlt: 0xff7a1a,
  flee: 0xbfe9ff,
  flame: 0xff7a1f,
  flameCore: 0xfff0a0,
  bonus: 0xff8ad8, // bonus.tint
  bonusGlow: 0xffb3d1,
  uiFrame: 0x2a2e4a,
  uiTrim: 0xf7d07a,
  uiCta: 0xff6a3d,
  brass: 0xc99a3a,
  brassLight: 0xf1cf7a,
  wood: 0x6b3f22,
  woodLight: 0x9a6236,
  skin: 0xf6c9a0,
  moustache: 0xfafafa,
  hudText: 0xfff8e8,
  fire: 0xff6a3d,
  fireDim: 0x5a2a22,
  fireRing: 0xffe0b0,
  dpad: 0x2a2536,
  dpadHeld: 0x4a4360,
  background: 0x120d0a,
  dimmer: 0x000000,
} as const;

/** CSS hex string for a token (DOM use). */
export function css(n: number): string {
  return `#${n.toString(16).padStart(6, '0')}`;
}
